import { render, staticRenderFns } from "./SurfaceTrashed.vue?vue&type=template&id=40421287&"
import script from "./SurfaceTrashed.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SurfaceTrashed.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SurfaceTrashed.vue?vue&type=style&index=0&id=40421287&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports